import BaseRepository from "./BaseRepository";

import { Auth } from "../../models";

export default class ComunicationsRepository extends BaseRepository {

	constructor() {
		super();
		this.edit = this.edit.bind(this);
		this.fetch = this.fetch.bind(this);
		this.create = this.create.bind(this);
	}

	async edit(user_id, body) {
		return await this.put(`/user/${user_id}/comunication`, body);
	}

	async fetch(user_id, filter, query) {
		return await this.get(`/user/${user_id}/comunication?filter=${filter}&query=${query}`);
	}

	async create(user_id, body) {
		return await this.post(`/user/${user_id}/comunication`, body);
	}
}


// WEBPACK FOOTER //
// src/api/lib/ComunicationsRepository.js